import { makeStyles } from "@material-ui/core/styles";
import { useIsAr } from "../../../Hooks";

export default makeStyles((theme) => {
  const { isAr } = useIsAr(theme.direction);

  return {
    tooltipContainer: {
      position: "relative",
      display: "inline-block",
      width: "fit-content",
    },

    tooltip: (props) => ({
      ...(isAr
        ? {
            fontFamily: "Inter",
          }
        : {}),
      position: "absolute",
      backgroundColor: theme.palette.background.primary_solid,
      color: theme.palette.text.white,
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
      zIndex: 1000,
      opacity: 0,
      transition: "opacity 0.3s ease, transform 0.3s ease",
      visibility: "hidden",
      whiteSpace: "nowrap",
      pointerEvents: "none", // Prevent tooltip from interfering with mouse events
      
      // Positioning based on placement prop
      ...(props.placement === "top" && {
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%) translateY(-8px)",
        marginBottom: "8px",
        "&::after": {
          content: '""',
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          border: "4px solid transparent",
          borderTopColor: theme.palette.background.primary_solid,
        },
      }),
      
      ...(props.placement === "bottom" && {
        top: "100%",
        left: "50%",
        transform: "translateX(-50%) translateY(8px)",
        marginTop: "8px",
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          border: "4px solid transparent",
          borderBottomColor: theme.palette.background.primary_solid,
        },
      }),
      
      ...(props.placement === "left" && {
        right: "100%",
        top: "50%",
        transform: "translateY(-50%) translateX(-8px)",
        marginRight: "8px",
        "&::after": {
          content: '""',
          position: "absolute",
          left: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          border: "4px solid transparent",
          borderLeftColor: theme.palette.background.primary_solid,
        },
      }),
      
      ...(props.placement === "right" && {
        left: "100%",
        top: "50%",
        transform: "translateY(-50%) translateX(8px)",
        marginLeft: "8px",
        "&::after": {
          content: '""',
          position: "absolute",
          right: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          border: "4px solid transparent",
          borderRightColor: theme.palette.background.primary_solid,
        },
      }),
    }),

    tooltipVisible: (props) => ({
      visibility: "visible",
      opacity: 1,
      
      // Adjust transform for visible state based on placement
      ...(props.placement === "top" && {
        transform: "translateX(-50%) translateY(0)",
      }),
      
      ...(props.placement === "bottom" && {
        transform: "translateX(-50%) translateY(0)",
      }),
      
      ...(props.placement === "left" && {
        transform: "translateY(-50%) translateX(0)",
      }),
      
      ...(props.placement === "right" && {
        transform: "translateY(-50%) translateX(0)",
      }),
    }),
  };
});
